import React from 'react';
import { MessageCircle } from 'lucide-react';
import GphRichBlock from '../GphRichBlock';
import { SUPPORT_COMMUNITY_URL } from '../../../services/gph/gphCopy';

// Suporte e comunidade dentro da conversa (link oficial existente).
export default function SupportCommunityAdapter({ agent }) {
  return (
    <GphRichBlock
      eyebrow="Suporte"
      title="SUPORTE E COMUNIDADE"
      subtitle="Fale com a comunidade oficial ou gerencie sua conta."
    >
      <div className="gph-block-actions">
        <a
          className="gph-btn gph-btn--primary"
          href={SUPPORT_COMMUNITY_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MessageCircle size={15} />
          Entrar na comunidade
        </a>
        <button
          type="button"
          className="gph-btn gph-btn--ghost"
          onClick={() => agent.runCapability('profile_plan', {})}
        >
          Ver meu plano
        </button>
        <button type="button" className="gph-btn gph-btn--ghost" onClick={() => agent.restart()}>
          Começar outro problema
        </button>
      </div>
    </GphRichBlock>
  );
}
